import { getTagList } from "@axios/api.account";
import { TagProps } from "@axios/models";
import {
  Button,
  Cascader,
  Col,
  Form,
  FormInstance,
  Input,
  Row,
  Spin
} from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { gaEvent } from "../../withTracker";
const { Item, List } = Form;

interface propsModel {
  onLoad(ref: FormInstance<any>): void;
}

export const DeviceForm = (props: propsModel) => {
  const [form] = Form.useForm();
  const [tagOptions, setTagOptions] = useState<any[]>();
  const [orgOptions, setOrgOptions] = useState<any[]>();
  const [loading, setLoading] = useState<boolean>(false);
  const { onLoad } = props;
  const { t } = useTranslation();
  useEffect(() => {
    onLoad(form);
    getOptions();
  }, []);

  const getOptions = () => {
    setLoading(true);
    // Promise.all([getTagList(), getOrganizationTree()]).then(([res1, res2]) => {
    //   const [tags, orgs] = formatOptions(res1, res2);
    //   setTagOptions(tags);
    //   setOrgOptions(orgs);
    //   setLoading(false);
    // });
    Promise.all([getTagList()]).then(([res1]) => {
      const [tags] = formatOptions(res1);
      setTagOptions(tags);
      setLoading(false);
    });
  };

  const formatOptions = (tags: TagProps[]) => {
    const resTags = tags.map(({ id, key, values }) => {
      return {
        value: id,
        label: key,
        children: values.map((item: any) => ({
          value: item.id,
          label: item.value,
        })),
      };
    });

    return [resTags];
  };

  return (
    <>
      <Spin spinning={loading}>
        <Form
          layout="horizontal"
          form={form}
          labelCol={{ span: 3 }}
          initialValues={{ tags: [] }}
        >
          <Item label="用户" name="owner" rules={[{ required: true }]}>
            <Input></Input>
          </Item>
          <Item label="账号" name="account" rules={[{ required: true }]}>
            <Input></Input>
          </Item>
          <Item label="密码" name="password" rules={[{ required: true }]}>
            <Input></Input>
          </Item>
          {/* <Item label="部门" name="organization" rules={[{ required: false }]}>
            <TreeSelect treeData={orgOptions} treeDefaultExpandAll></TreeSelect>
          </Item> */}
          <List name="tags">
            {(fields, { add, remove }) => (
              <>
                {fields.map((field) => (
                  <Item key={field.key} labelCol={{span:3}} label="设备组">
                    <Row justify="space-between">
                      <Col span="21">
                        <Item noStyle                       
                          {...field}                    
                          name={[field.name, "tag"]}
                          // fieldKey={[field.fieldKey, "tag"]}
                        >
                          <Cascader options={tagOptions} />
                        </Item>
                      </Col>
                      <Col>
                        <Button type="dashed" onClick={() => {remove(field.name);gaEvent("deviceAdd","onClick","remove")}}>-</Button>
                      </Col>
                    </Row>
                  </Item>
                ))}
                <Form.Item wrapperCol={{offset:3}}>
                  <Button type="dashed" onClick={() => {add();gaEvent("deviceAdd","onClick","add")}} block>
                  {t("添加设备组")}
                  </Button>
                </Form.Item>
              </>
            )}
          </List>
          {/*  <Item label="标签" name="tag" rules={[{ required: false }]}>
            <Cascader options={tagOptions} />
          </Item> */}
        </Form>
      </Spin>
    </>
  );
};
